module.exports = __webpack_public_path__ + "img/back_29.341ceb27.svg";